<template lang="pug" src="./banner-icon-text-button.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  data () {
    return {
      active: '',
      modal: false
    }
  },
  components: {
    Icon
  },
  methods: {
    activate (i) {
      this.active === i ? this.active = '' : this.active = i
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/banner/banner-icon-text-button/banner-icon-text-button.vue